module.exports = __webpack_public_path__ + "static/img/logo.63ecfd72.jpg";